"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CompanyType = _interopRequireDefault(require("./CompanyType"));

var _ContactType = _interopRequireDefault(require("./ContactType"));

var _DealType = _interopRequireDefault(require("./DealType"));

var _FeedbackSubmissionType = _interopRequireDefault(require("./FeedbackSubmissionType"));

var _react = require("react");

var _VisitType = _interopRequireDefault(require("./VisitType"));

var _TicketType = _interopRequireDefault(require("./TicketType"));

var _EngagementType = _interopRequireDefault(require("./EngagementType"));

var SubjectType = _react.PropTypes.oneOfType([_CompanyType.default.isRequired, _ContactType.default.isRequired, _DealType.default.isRequired, _FeedbackSubmissionType.default.isRequired, _VisitType.default.isRequired, _TicketType.default.isRequired, _EngagementType.default.isRequired]);

var _default = SubjectType;
exports.default = _default;
module.exports = exports.default;